<template>
<div>
  <div class="pa-md">
    <!-- Task is loaded -->
    <div v-if="!loading">
      <p class="has-text-centered has-text-weight-bold mb-lg is-size-5">Primary Contacts</p>
      <div class="columns is-centered">
        <div class="column is-half">
          <div class="box">
            <transition name="fade" mode="out-in">
              <component :is="step"
                :connection="connection"
                :task="task"
                :users="users"
                :supplier="supplier"
                @navigate="navigate"
                @invite:user="showInviteModal = true"
                @contact:updated="loadSupplier(true)"
              ></component>
            </transition>
          </div>
          <!-- Return & Reset Links -->
          <div class="columns is-centered">
            <router-link :to="{ name: 'onboarding.tasks', params: { connection: this.$route.params.connection }}" class="column is-size-7 ml-sm" :class="!isCompleted && 'has-text-centered'">
              Back to Tasks
            </router-link>
            <a v-if="isCompleted" href="#" class="column is-size-7 has-text-right mr-sm" @click="showResetTaskModal=true">
              Reset Task
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Loading Skeleton -->
    <div v-else>
      <div class="mb-md">
        <div class="columns is-centered">
          <div class="column is-one-quarter">
            <b-skeleton />
          </div>
        </div>
      </div>
      <div class="columns is-centered">
        <div class="column is-half">
          <div class="box">
            <loading message="Loading..." />
          </div>
          <!-- Return Link -->
          <div class="has-text-centered">
            <router-link :to="{ name: 'onboarding.tasks', params: { connection: this.$route.params.connection }}" class="is-size-7">
              Back to Tasks
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Create Modal -->
  <b-modal
    :has-modal-card="true"
    :active.sync="showInviteModal"
    :can-cancel="['x']"
  ><InviteUserModal @invited:user="loadUsers(true)" />
  </b-modal>
  <!-- Reset Task Modal -->
  <b-modal
    v-if="!loading && task !== null"
    :has-modal-card="true"
    :active.sync="showResetTaskModal"
    :can-cancel="['x', 'esc']">
    <ResetTaskModal :taskId="task.id" @task:reset="onTaskReset" />
  </b-modal>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import InviteUserModal from '@/components/Models/User/Modals/InviteUserModal'
import ResetTaskModal from '@/components/Models/Task/Modals/ResetTaskModal'
import Intro from '../components/Contacts/Intro'
import PrimaryContact from '../components/Contacts/PrimaryContact'
import MerchandisingContact from '../components/Contacts/MerchandisingContact'
import FulfillmentContact from '../components/Contacts/FulfillmentContact'
import Confirmation from '../components/Contacts/Confirmation'

export default {
  components: {
    InviteUserModal,
    ResetTaskModal,
    Intro,
    PrimaryContact,
    MerchandisingContact,
    FulfillmentContact,
    Confirmation
  },
  computed: {
    ...mapGetters(['app', 'context']),
    loading () {
      return (this.loadingUsers || this.loadingSupplier)
    },
    isCompleted () {
      return this.task && this.task.completed_at !== null
    }
  },
  data () {
    return {
      loadingUsers: true,
      loadingSupplier: true,
      loadingTask: true,
      task: null,
      users: [],
      supplier: null,
      step: 'Intro',
      showInviteModal: false,
      showResetTaskModal: false
    }
  },
  methods: {
    loadTask () {
      this.loadingTask = true
      const endpoint = this.context.route + '/assigned-tasks/' + this.$route.params.task + '/'
      this.$http.get(endpoint).then(response => {
        this.task = response.data
        this.loadingTask = false
      })
    },
    loadUsers (quiet = false) {
      if (!quiet) this.loadingUsers = true
      const endpoint = this.context.route + '/users/'
      const query = {
        params: {
          mini: 1,
          pagination: 0,
          order_by: 'first_name'
        }
      }
      this.$http.get(endpoint, query).then(response => {
        this.users = response.data.results
        this.loadingUsers = false
      })
    },
    loadSupplier (quiet = false) {
      if (!quiet) this.loadingSupplier = true
      const endpoint = this.context.route + '/'
      this.$http.get(endpoint).then(response => {
        this.supplier = response.data
        this.businessContact = (this.supplier.connections_manager) ? this.supplier.connections_manager.id : null
        this.merchandisingContact = (this.supplier.merchandising_manager) ? this.supplier.merchandising_manager.id : null
        this.transactionsContact = (this.supplier.shipping_manager) ? this.supplier.shipping_manager.id : null
        this.loadingSupplier = false
      })
    },
    navigate (step) {
      this.step = step
    },
    onTaskReset () {
      this.$buefy.toast.open({ type: 'is-info', message: 'Task reset successfully.' })
      this.$router.push({ name: 'onboarding.tasks', params: { connection: this.$route.params.connection } })
    }
  },
  mounted () {
    this.loadTask()
    this.loadUsers()
    this.loadSupplier()
  },
  props: ['connection']
}
</script>
